/* src/app/components/elibraryandcourse/e-library/e-library-details/e-library-list/e-library-list.component.scss */
:host {
  display: block;
  width: 100%;
}
.topicListView {
  width: 100%;
  margin: 0;
  padding: 24px;
  border: 0;
  border-radius: 18px;
  background: #f6f8fc;
  box-shadow: none;
}
.topicListView .library-header {
  margin-bottom: 22px;
}
.library-stats {
  display: grid;
  grid-template-columns: minmax(200px, 1.4fr) repeat(2, minmax(180px, 1fr));
  gap: 16px;
  width: 100%;
}
.stat-card {
  min-height: 86px;
  padding: 17px 20px;
  display: flex;
  align-items: center;
  gap: 14px;
  background: #ffffff;
  border: 1px solid #e8ecf3;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
  transition: all 0.2s ease;
}
.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(15, 23, 42, 0.07);
  border-color: rgba(79, 70, 229, 0.18);
}
.stat-card .stat-value {
  display: block;
  color: #172033;
  font-size: 25px;
  line-height: 1.1;
  font-weight: 700;
}
.stat-card .stat-label {
  display: block;
  margin-top: 4px;
  color: #718096;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.stat-icon {
  width: 48px;
  height: 48px;
  min-width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 19px;
}
.stat-icon.documents {
  color: #4f46e5;
  background: #eef2ff;
}
.stat-icon.users {
  color: #0891b2;
  background: #ecfeff;
}
.select-all-card {
  padding-left: 20px;
}
.select-all {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 11px;
  cursor: pointer;
  color: #172033;
  font-size: 14px;
  font-weight: 600;
  -webkit-user-select: none;
  user-select: none;
}
.select-all input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.select-all .custom-check {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid #cbd5e1;
  border-radius: 6px;
  background: #fff;
  transition: all 0.2s ease;
}
.select-all .custom-check i {
  opacity: 0;
  color: #fff;
  font-size: 11px;
  transition: opacity 0.15s ease;
}
.select-all input:checked + .custom-check {
  border-color: #4f46e5;
  background: #4f46e5;
}
.select-all input:checked + .custom-check i {
  opacity: 1;
}
.topicListView > table {
  width: 100%;
  margin: 0;
  overflow: hidden;
  border: 1px solid #e8ecf3;
  border-radius: 14px;
  border-collapse: separate;
  border-spacing: 0;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
}
.topicListView > table thead {
  background: #f8fafc;
}
.topicListView > table thead th {
  padding: 15px 18px;
  border-bottom: 1px solid #e8ecf3;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  white-space: nowrap;
}
.topicListView > table tbody tr {
  background: #ffffff;
  transition: background 0.18s ease;
}
.topicListView > table tbody tr:hover {
  background: #fafbff;
}
.topicListView > table tbody tr:last-child td {
  border-bottom: 0;
}
.topicListView > table tbody td {
  height: 68px;
  padding: 13px 18px;
  border-bottom: 1px solid #edf0f5;
  color: #172033;
  font-size: 13px;
  vertical-align: middle;
}
.topicListView > table tbody td:first-child {
  font-weight: 600;
}
.list-ellipsis {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.topicListView td:last-child {
  white-space: nowrap;
}
.topicListView td:last-child > a.button,
.topicListView td:last-child > .button {
  width: 34px;
  height: 34px;
  min-height: 34px;
  margin-right: 5px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e8ecf3;
  border-radius: 9px;
  background: #fff;
  color: #64748b;
  box-shadow: none;
  transition: all 0.2s ease;
}
.topicListView td:last-child > a.button:hover,
.topicListView td:last-child > .button:hover {
  color: #4f46e5;
  border-color: #c7d2fe;
  background: #eef2ff;
  transform: translateY(-1px);
}
.topicListView .dropdown {
  position: relative;
  display: inline-flex !important;
  width: 34px;
  height: 34px;
  padding: 0 !important;
  margin: 0;
  border: 1px solid #e8ecf3 !important;
  border-radius: 9px;
  background: #fff !important;
  vertical-align: middle;
  box-shadow: none !important;
}
.topicListView .dropdown .dropdown-trigger {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.topicListView .dropdown .dropdown-trigger a {
  width: 100%;
  height: 100%;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
}
.topicListView .dropdown .dropdown-menu {
  position: absolute;
  z-index: 100;
  top: calc(100% + 8px);
  right: 0;
  min-width: 190px;
  padding-top: 0;
  display: none;
}
.topicListView .dropdown.is-active {
  border-color: #c7d2fe !important;
  background: #eef2ff !important;
}
.topicListView .dropdown.is-active .dropdown-menu {
  display: block;
}
.topicListView .dropdown.is-active .dropdown-trigger a {
  color: #4f46e5;
}
.topicListView .dropdown .dropdown-content {
  padding: 7px;
  overflow: hidden;
  border: 1px solid #e8ecf3;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 15px 40px rgba(15, 23, 42, 0.14);
}
.topicListView .dropdown .dropdown-item {
  min-height: 38px;
  padding: 9px 11px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  color: #475569;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}
.topicListView .dropdown .dropdown-item i {
  width: 16px;
  color: #64748b;
  text-align: center;
}
.topicListView .dropdown .dropdown-item:hover {
  color: #4f46e5;
  background: #f1f5ff;
}
.topicListView .dropdown .dropdown-item:hover i {
  color: #4f46e5;
}
.topicListView .dropdown .dropdown-divider {
  margin: 6px 4px;
  border-top: 1px solid #e8ecf3;
}
.topic-notify {
  margin: 30px 0;
  padding: 60px 20px;
  border: 1px dashed #d7ddea;
  border-radius: 16px;
  background: #fafbfe;
  box-shadow: none;
}
.topic-notify p {
  margin: 0;
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
}
.topic-notify::before {
  content: "\f07b";
  width: 56px;
  height: 56px;
  margin: 0 auto 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #eef2ff;
  color: #4f46e5;
  font-family: "Font Awesome 6 Free";
  font-size: 22px;
  font-weight: 900;
}
.elibPlaying-Media {
  width: 100%;
  padding: 24px;
  background: #f6f8fc;
}
.elibPlaying-Media .columns {
  margin: 0 -8px;
}
.elibPlaying-Media .column {
  padding: 8px;
}
.elibPlaying-Media .card {
  height: 100%;
  overflow: hidden;
  border: 1px solid #e8ecf3;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
}
.elibPlaying-Media .card-content {
  padding: 22px;
}
.cs-media-player {
  width: 100%;
  overflow: hidden;
  border-radius: 14px;
  background: #111827;
}
.cs-media-player vg-player {
  width: 100%;
  min-height: 420px;
}
.cs-media-player video {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.mediaDocFile {
  min-height: 420px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  border-radius: 14px;
}
.mediaDocFile .imgFigure {
  text-align: center;
}
.mediaDocFile .tile_imgcenter {
  width: 85px;
  height: 85px;
  margin-bottom: 20px;
  object-fit: contain;
}
.thumb_play {
  border-radius: 9px !important;
}
.cs-mediaplayer .title {
  margin: 18px 0 4px;
  color: #172033;
  font-size: 16px !important;
  font-weight: 700;
}
.cs-mediaplayer .shared {
  margin: 0;
  color: #718096;
  font-size: 12px;
}
.cs-mediaplayer .pagination {
  margin-top: 20px;
  justify-content: space-between;
}
.cs-mediaplayer .pagination button {
  min-height: 36px;
  border: 1px solid #e8ecf3;
  border-radius: 9px;
  background: #fff;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
}
.cs-mediaplayer .pagination button:hover:not(:disabled) {
  color: #4f46e5;
  border-color: #c7d2fe;
  background: #eef2ff;
}
.cs-mediaplayer .pagination button:disabled {
  opacity: 0.45;
}
.events-card .card-header {
  min-height: 58px;
  border-bottom: 1px solid #e8ecf3;
  box-shadow: none;
}
.events-card .card-header-title {
  padding: 17px 18px;
  color: #172033;
  font-size: 14px;
  font-weight: 700;
}
.list-wrapper {
  max-height: 520px;
  overflow-y: auto;
}
.notification-list {
  margin: 0;
  padding: 8px;
  list-style: none;
}
.notification-list li.chat-list {
  margin-bottom: 5px;
  padding: 13px;
  border-radius: 10px;
  transition: all 0.18s ease;
}
.notification-list li.chat-list:hover {
  background: #f8faff;
}
.notification-list li.chat-list.selectedActive {
  background: #eef2ff;
  box-shadow: inset 3px 0 0 #4f46e5;
}
.notification-list li.chat-list.selectedActive .title {
  color: #4f46e5;
}
.notification-list li.chat-list .title {
  margin: 0 0 5px;
  color: #172033;
  font-size: 13px !important;
  font-weight: 600;
}
.notification-list li.chat-list .shared {
  margin: 0;
  color: #94a3b8;
  font-size: 11px;
}
.library_tile_view {
  width: 100%;
  padding: 24px;
  background: #f6f8fc;
}
.editedFileUpload {
  width: 100%;
}
.editedFileUpload > .flex-item {
  width: 100% !important;
}
.editedFileUpload .card {
  overflow: hidden;
  border: 1px solid #e8ecf3;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
}
.editedFileUpload .card-header {
  min-height: 62px;
  border-bottom: 1px solid #e8ecf3;
  background: #fff;
  box-shadow: none;
}
.editedFileUpload .card-header .card-header-title {
  padding: 18px 22px;
  color: #172033;
  font-size: 16px;
  font-weight: 700;
}
.editedFileUpload .card-content {
  padding: 24px;
}
.editedFileUpload .field {
  margin-bottom: 18px;
}
.editedFileUpload .label {
  margin-bottom: 7px;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
}
.editedFileUpload .required {
  color: #ef4444;
}
.editedFileUpload .input,
.editedFileUpload .textarea,
.editedFileUpload select {
  width: 100%;
  border: 1px solid #dfe4ec;
  border-radius: 9px;
  background: #fff;
  color: #172033;
  box-shadow: none;
  transition: all 0.2s ease;
}
.editedFileUpload .input:hover,
.editedFileUpload .textarea:hover,
.editedFileUpload select:hover {
  border-color: #cbd5e1;
}
.editedFileUpload .input:focus,
.editedFileUpload .textarea:focus,
.editedFileUpload select:focus {
  border-color: #a5b4fc;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.08);
}
.editedFileUpload .input::placeholder,
.editedFileUpload .textarea::placeholder,
.editedFileUpload select::placeholder {
  color: #a0aabd;
}
.editedFileUpload .input {
  height: 42px;
}
.editedFileUpload .textarea {
  min-height: 100px;
  resize: vertical;
}
.post-attach-file .file {
  width: 100%;
}
.post-attach-file .file-label {
  width: 100%;
}
.post-attach-file .file-cta {
  width: 100%;
  min-height: 100px;
  justify-content: center;
  flex-direction: column;
  gap: 7px;
  border: 1px dashed #c7d2fe;
  border-radius: 12px;
  background: #f8faff;
  color: #4f46e5;
  transition: all 0.2s ease;
}
.post-attach-file .file-cta:hover {
  border-color: #4f46e5;
  background: #eef2ff;
}
.post-attach-file .file-icon {
  font-size: 20px;
}
.post-attach-file .file-label {
  color: #64748b;
  font-size: 12px;
}
.editedFileUpload .is-small .delete {
  margin-left: 10px;
}
.editedFileUpload .is-small img {
  margin-right: 8px;
  vertical-align: middle;
}
.editedFileUpload .radio {
  margin-right: 15px;
  color: #64748b;
  font-size: 12px;
}
.editedFileUpload .tabs {
  margin-bottom: 20px;
}
.editedFileUpload .tabs ul {
  border-bottom: 1px solid #e8ecf3 !important;
}
.editedFileUpload .tabs li {
  margin-bottom: -1px;
}
.editedFileUpload .tabs li a {
  min-height: 42px;
  padding: 10px 18px;
  border: 0 !important;
  border-bottom: 2px solid transparent !important;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.2s ease;
}
.editedFileUpload .tabs li:hover a {
  color: #4f46e5;
}
.editedFileUpload .tabs li.is-active a {
  border-bottom-color: #4f46e5 !important;
  color: #4f46e5;
  background: transparent !important;
}
.questionnarie {
  position: relative;
  margin-bottom: 18px;
  padding: 18px;
  border: 1px solid #e8ecf3;
  border-radius: 12px;
  background: #fafbfe;
}
.questionnarie .input {
  margin-bottom: 10px;
}
.questionnarie .removeAssQuestion {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
  color: #94a3b8 !important;
  cursor: pointer;
}
.questionnarie .removeAssQuestion:hover {
  color: #ef4444 !important;
}
.question-option {
  margin-top: 10px;
  padding: 10px;
  border-left: 2px solid #e0e7ff;
}
.question-option .control {
  position: relative;
  margin-bottom: 8px;
}
.question-option .control .input {
  padding-right: 38px;
}
.question-option .control .removeOptions {
  position: absolute;
  top: 11px;
  right: 10px;
  color: #94a3b8 !important;
  cursor: pointer;
}
.question-option .control .removeOptions:hover {
  color: #ef4444 !important;
}
.editedFileUpload .button,
.library_tile_view .button {
  min-height: 36px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.2s ease;
}
.button.is-link {
  border-color: #4f46e5;
  background: #4f46e5;
}
.button.is-link:hover {
  border-color: #4338ca;
  background: #4338ca;
  transform: translateY(-1px);
}
.button.is-link.is-outlined {
  border-color: #c7d2fe;
  background: #fff;
  color: #4f46e5;
}
.button.is-link.is-outlined:hover {
  border-color: #4f46e5;
  background: #eef2ff;
}
.editedFileUpload .card-footer {
  padding: 15px 22px;
  border-top: 1px solid #e8ecf3;
  background: #fafbfc;
  box-shadow: none;
}
.editedFileUpload .card-footer .column {
  padding: 0;
}
.showAssignment .modal {
  z-index: 1000;
}
.showAssignment .modal-background {
  background: rgba(15, 23, 42, 0.58);
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
}
.showAssignment .modal-card {
  width: min(760px, 100% - 32px);
  max-height: calc(100vh - 60px);
  overflow: hidden;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 25px 70px rgba(15, 23, 42, 0.25);
}
.showAssignment .modal-card > .card {
  border: 0;
  box-shadow: none;
}
.showAssignment .card-header {
  min-height: 62px;
  border-bottom: 1px solid #e8ecf3;
  box-shadow: none;
}
.showAssignment .card-header .card-header-title {
  padding: 18px 22px;
  color: #172033;
  font-size: 16px;
  font-weight: 700;
}
.showAssignment .card-header .delete {
  margin: auto 16px;
  background-color: #f1f5f9;
}
.showAssignment .card-content {
  padding: 24px;
}
.showAssignment .card-footer {
  padding: 15px 22px;
  justify-content: flex-end;
  border-top: 1px solid #e8ecf3;
}
.showAssignment .question h3 {
  margin-bottom: 16px;
  color: #172033;
  font-weight: 700;
}
.showAssignment .question .options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.showAssignment .question .option {
  padding: 11px 14px;
  border: 1px solid #e8ecf3;
  border-radius: 9px;
  background: #fff;
  transition: all 0.15s ease;
}
.showAssignment .question .option:hover {
  border-color: #c7d2fe;
  background: #fafbff;
}
.showAssignment .question .field {
  margin-bottom: 0;
}
.showAssignment .question label {
  color: #475569;
  font-size: 13px !important;
  cursor: pointer;
}
.currentResult p.heading {
  margin-bottom: 4px;
  color: #718096;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}
.currentResult p.title {
  color: #172033;
  font-size: 24px;
  font-weight: 800;
}
.showAssignment table {
  border-collapse: separate;
  border-spacing: 0;
  overflow: hidden;
  border: 1px solid #e8ecf3;
  border-radius: 10px;
}
.showAssignment table th {
  padding: 12px 15px;
  background: #f8fafc;
  color: #64748b;
  font-size: 11px;
  text-transform: uppercase;
}
.showAssignment table td {
  padding: 13px 15px;
  border-bottom: 1px solid #e8ecf3;
  font-size: 13px;
}
.surveyquiz .progress {
  height: 7px;
  margin-top: 8px;
  border-radius: 20px;
  background: #e2e8f0;
}
.badge-info {
  display: inline-flex;
  margin-bottom: 10px;
  padding: 5px 9px;
  border-radius: 20px;
  background: #eef2ff;
  color: #4f46e5;
  font-size: 11px;
  font-weight: 700;
}
.showAssignment ngx-doc-viewer {
  display: block;
  overflow: hidden;
  border-radius: 14px;
}
.scroll-bar,
.list-wrapper {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.scroll-bar::-webkit-scrollbar,
.list-wrapper::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.scroll-bar::-webkit-scrollbar-track,
.list-wrapper::-webkit-scrollbar-track {
  background: transparent;
}
.scroll-bar::-webkit-scrollbar-thumb,
.list-wrapper::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background: #cbd5e1;
}
.scroll-bar::-webkit-scrollbar-thumb:hover,
.list-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
.hiddenDownloadLink {
  display: none !important;
}
@media (max-width: 992px) {
  .library-stats {
    grid-template-columns: 1fr 1fr;
  }
  .select-all-card {
    grid-column: 1/-1;
  }
  .elibPlaying-Media,
  .library_tile_view,
  .topicListView {
    padding: 16px;
  }
  .cs-media-player vg-player {
    min-height: 320px;
  }
  .list-wrapper {
    max-height: 350px;
  }
}
@media (max-width: 768px) {
  .library-stats {
    grid-template-columns: 1fr;
  }
  .select-all-card {
    grid-column: auto;
  }
  .topicListView {
    overflow-x: hidden;
  }
  .topicListView > table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
  .topicListView > table thead,
  .topicListView > table tbody,
  .topicListView > table tr {
    width: 100%;
  }
  .topicListView > table th,
  .topicListView > table td {
    min-width: 130px;
  }
  .topicListView > table th:first-child,
  .topicListView > table td:first-child {
    min-width: 200px;
  }
  .topicListView > table th:last-child,
  .topicListView > table td:last-child {
    min-width: 180px;
  }
  .list-ellipsis {
    max-width: 200px;
  }
  .cs-media-player vg-player {
    min-height: 250px;
  }
  .mediaDocFile {
    min-height: 280px;
  }
  .editedFileUpload .card-content {
    padding: 16px;
  }
  .showAssignment .modal-card {
    width: calc(100% - 20px);
    max-height: calc(100vh - 20px);
  }
}
@media (max-width: 480px) {
  .topicListView,
  .elibPlaying-Media,
  .library_tile_view {
    padding: 10px;
  }
  .stat-card {
    min-height: 76px;
    padding: 14px;
  }
  .stat-icon {
    width: 42px;
    height: 42px;
    min-width: 42px;
  }
  .stat-value {
    font-size: 21px !important;
  }
  .topicListView > table th,
  .topicListView > table td {
    padding: 11px 12px;
  }
  .questionnarie {
    padding: 14px;
  }
  .question-option {
    padding: 7px;
  }
  .showAssignment .card-content {
    padding: 16px;
  }
  .showAssignment .card-footer {
    padding: 12px;
  }
}
@keyframes libraryFadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.topicListView,
.elibPlaying-Media,
.library_tile_view {
  animation: libraryFadeIn 0.25s ease-out;
}
/*# sourceMappingURL=e-library-list.component.css.map */
